import { render, staticRenderFns } from "./MonitoringTargetDetail.vue?vue&type=template&id=6ac82486"
import script from "./MonitoringTargetDetail.vue?vue&type=script&lang=ts"
export * from "./MonitoringTargetDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports